<script setup>
import Header from "./Header.vue"
import api from "../api/api"
import BaseButton from "./UI/BaseButton.vue"
import BaseInput from "./UI/BaseInput.vue"
import ButtonSubmit from "./ButtonSubmit.vue"
import ButtonCancel from "./ButtonCancel.vue"
import { flashMessage } from "@/functions"
</script>

<template>
  <div class="body-container">
    <header>
      <h2>Threshold Settings</h2>
      <h2>T01</h2>
    </header>

    <div class="settings-body">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Caller ID</th>
            <th>Caller Member</th>
            <th>IP Address</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Threshold Active?</td>
            <td>
              <fieldset id="taCI">
                <div>
                  <input
                    type="radio"
                    name="taCI"
                    id="taCI-yes"
                    value="1"
                    v-model="dataSettingsCI.thresholdActive" />
                  <label for="taCI-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="taCI"
                    id="taCI-no"
                    value="0"
                    v-model="dataSettingsCI.thresholdActive" />
                  <label for="taCI-no">No</label>
                </div>
              </fieldset>
            </td>
            <td>
              <fieldset id="taCM">
                <div>
                  <input
                    type="radio"
                    name="taCM"
                    id="taCM-yes"
                    value="1"
                    v-model="dataSettingsCM.thresholdActive" />
                  <label for="taCM-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="taCM"
                    id="taCM-no"
                    value="0"
                    v-model="dataSettingsCM.thresholdActive" />
                  <label for="taCM-no">No</label>
                  <!-- <label for="taCM-no" style="position: relative; top: 1px">No</label> -->
                </div>
              </fieldset>
            </td>
            <td>
              <fieldset id="taIA">
                <div>
                  <input
                    type="radio"
                    name="taIA"
                    id="taIA-yes"
                    value="1"
                    v-model="dataSettingsIA.thresholdActive" />
                  <label for="taIA-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="taIA"
                    id="taIA-no"
                    value="0"
                    v-model="dataSettingsIA.thresholdActive" />
                  <label for="taCM-no">No</label>
                </div>
              </fieldset>
            </td>
          </tr>
          <tr>
            <td>Number of hours to look back when determining if a threshold has been exceeded:</td>
            <td>
              <BaseInput
                type="number"
                name="numberOfHoursCI"
                id="numberOfHoursCI"
                v-model="dataSettingsCI.numberOfHours" />
                <br>
            </td>
            <td>
              <BaseInput
                type="number"
                name="numberOfHoursCM"
                id="numberOfHoursCM"
                v-model="dataSettingsCM.numberOfHours" />
                <br>
            </td>
            <td>
              <BaseInput
                type="number"
                name="numberOfHoursIA"
                id="numberOfHoursIA"
                v-model="dataSettingsIA.numberOfHours" />
                <br>
            </td>
          </tr>
          <tr>
            <td>Send or display alert when number of calls/member inquiries meets or exceeds:</td>
            <td>
              <BaseInput
                type="number"
                name="maxNumberOfCallsCI"
                id="maxNumberOfCallsCI"
                v-model="dataSettingsCI.numberOfCalls" />
                <br>
            </td>
            <td>
              <BaseInput
                type="number"
                name="maxNumberOfCallsCM"
                id="maxNumberOfCallsCM"
                v-model="dataSettingsCM.numberOfCalls" />
                <br>
            </td>
            <td>
              <BaseInput
                type="number"
                name="maxNumberOfCallsIA"
                id="maxNumberOfCallsIA"
                v-model="dataSettingsIA.numberOfCalls" />
            </td>
          </tr>
          <tr>
            <td>Send email when threshold meets or exceeds?</td>
            <td>
              <fieldset id="sendEmailCI">
                <div>
                  <input
                    type="radio"
                    name="sendEmailCI"
                    id="sendEmailCI-yes"
                    value="1"
                    v-model="dataSettingsCI.thresholdEmailExceeds" />
                  <label for="sendEmailCI-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="sendEmailCI"
                    id="sendEmailCI-no"
                    value="0"
                    v-model="dataSettingsCI.thresholdEmailExceeds" />
                  <label for="sendEmailCI-no">No</label>
                </div>
              </fieldset>
            </td>
            <td>
              <fieldset id="sendEmailCM">
                <div>
                  <input
                    type="radio"
                    name="sendEmailCM"
                    id="sendEmailCM-yes"
                    value="1"
                    v-model="dataSettingsCM.thresholdEmailExceeds" />
                  <label for="sendEmailCM-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="sendEmailCM"
                    id="sendEmailCM-no"
                    value="0"
                    v-model="dataSettingsCM.thresholdEmailExceeds" />
                  <label for="sendEmailCM-no">No</label>
                </div>
              </fieldset>
            </td>
            <td>
              <fieldset id="sendEmailIA">
                <div>
                  <input
                    type="radio"
                    name="sendEmailIA"
                    id="sendEmailIA-yes"
                    value="1"
                    v-model="dataSettingsIA.thresholdEmailExceeds" />
                  <label for="sendEmailCM-yes">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="sendEmailIA"
                    id="sendEmailIA-no"
                    value="0"
                    v-model="dataSettingsIA.thresholdEmailExceeds" />
                  <label for="sendEmailIA-no">No</label>
                </div>
              </fieldset>
            </td>
          </tr>
          <tr>
            <td>Threshold alert email addresses:<br>(separate with comma)</td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCI"
                id="alertEmailAddressCI"
                v-model="dataSettingsCI.thresholdEmailAddressAlert" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCM"
                id="alertEmailAddressCM"
                v-model="dataSettingsCM.thresholdEmailAddressAlert" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressIA"
                id="alertEmailAddressIA"
                v-model="dataSettingsIA.thresholdEmailAddressAlert" />
            </td>
          </tr>
          <tr>
            <td>Threshold alert cc email addresses:<br>(separate with comma)</td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCI"
                id="alertEmailAddressCI"
                v-model="dataSettingsCI.thresholdEmailAddressCC" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCM"
                id="alertEmailAddressCM"
                v-model="dataSettingsCM.thresholdEmailAddressCC" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressIA"
                id="alertEmailAddressIA"
                v-model="dataSettingsIA.thresholdEmailAddressCC" />
            </td>
          </tr>
          <tr>
            <td>Threshold alert bcc email addresses:<br>(separate with comma)</td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCI"
                id="alertEmailAddressCI"
                v-model="dataSettingsCI.thresholdEmailAddressBCC" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCM"
                id="alertEmailAddressCM"
                v-model="dataSettingsCM.thresholdEmailAddressBCC" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressIA"
                id="alertEmailAddressIA"
                v-model="dataSettingsIA.thresholdEmailAddressBCC" />
            </td>
          </tr>
          <tr>
            <td>Email subject:</td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCI"
                id="alertEmailAddressCI"
                v-model="dataSettingsCI.thresholdEmailSubject" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressCM"
                id="alertEmailAddressCM"
                v-model="dataSettingsCM.thresholdEmailSubject" />
            </td>
            <td>
              <BaseInput
                type="email"
                name="alertEmailAddressIA"
                id="alertEmailAddressIA"
                v-model="dataSettingsIA.thresholdEmailSubject" />
            </td>
          </tr>
          <tr>
            <td>Warning message to be displayed or emailed when threshold is met or exceeded:</td>
            <td>
              <textarea
                rows="5"
                name="warningMessageCI"
                id="warningMessageCI"
                v-model="dataSettingsCI.warningMessage"
                placeholder="Global Warning: This caller ID has called %times in the last %hours hours.">
              </textarea>
            </td>
            <td>
              <textarea
                rows="5"
                name="warningMessageCM"
                id="warningMessageCM"
                v-model="dataSettingsCM.warningMessage"
                placeholder="Global Warning: This member number has been used %times in the last %hours hours."
                >
              </textarea>
            </td>
            <td>
              <textarea
                rows="5"
                name="warningMessageIA"
                id="warningMessageIA"
                v-model="dataSettingsIA.warningMessage"
                placeholder="Global Warning: This member number has been used %times with different IP Addresses in the last %hours hours."
                >
              </textarea>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <ButtonSubmit type="button" label="Update" @click="updateThresholdSettings" />
              <ButtonCancel type="button" label="Cancel" @click="cancelThresholdSettings" />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThresholdSettingsComponent",
  component: [Header, BaseButton, BaseInput],
  props: ["brandData"],
  data: () => {
    return {
      companyID: localStorage.getItem('companyID'),
      user: localStorage.getItem("passLoginUp"),
      dataSettingsCI: {
        thresholdActive: "",
        numberOfHours: 0,
        numberOfCalls: 0,
        thresholdEmailExceeds: "0",
        thresholdEmailAddressAlert: "",
        warningMessage: "",
        thresholdEmailAddressCC: "",
        thresholdEmailAddressBCC: "",
        thresholdEmailSubject: "",
      },
      dataSettingsCM: {
        thresholdActive: "",
        numberOfHours: 0,
        numberOfCalls: 0,
        thresholdEmailExceeds: "0",
        thresholdEmailAddressAlert: "",
        warningMessage: "",
        thresholdEmailAddressCC: "",
        thresholdEmailAddressBCC: "",
        thresholdEmailSubject: "",
      },
      dataSettingsIA: {
        thresholdActive: 0,
        numberOfHours: 0,
        numberOfCalls: 0,
        thresholdEmailExceeds: 0,
        thresholdEmailAddressAlert: "",
        warningMessage: "",
        thresholdEmailAddressCC: "",
        thresholdEmailAddressBCC: "",
        thresholdEmailSubject: "",
      },
      warningMessageCI: "",
      warningMessageCM: "",
    }
  },
  mounted() {
    this.getThresholdSettings()
  },
  methods: {
    async getThresholdSettings() {
      try {
        const { data } = await api.get(`/update_threshold/${this.companyID}`)
        console.log(data[0])

        // Caller ID
        this.dataSettingsCI.numberOfCalls = data[0].MaxNumCallsCaller
        this.dataSettingsCI.numberOfHours = data[0].NumHoursCaller
        this.dataSettingsCI.thresholdEmailAddressAlert = data[0].EmailAddressCaller
        this.dataSettingsCI.thresholdActive = data[0].ThresholdActiveCaller
        this.dataSettingsCI.thresholdEmailExceeds = data[0].SendEmailCaller
        this.dataSettingsCI.thresholdEmailAddressCC = data[0].EmailAddressCCCaller
        this.dataSettingsCI.thresholdEmailAddressBCC = data[0].EmailAddressBCCCaller
        this.dataSettingsCI.thresholdEmailSubject = data[0].EmailSubjectCaller
        this.dataSettingsCI.warningMessage = data[0].WarningMessageCaller

        // Caller Member
        this.dataSettingsCM.numberOfCalls = data[0].MaxNumCallsMember
        this.dataSettingsCM.numberOfHours = data[0].NumHoursMember
        this.dataSettingsCM.thresholdEmailAddressAlert = data[0].EmailAddressMember
        this.dataSettingsCM.thresholdActive = data[0].ThresholdActiveMember
        this.dataSettingsCM.thresholdEmailExceeds = data[0].SendEmailMember
        this.dataSettingsCM.thresholdEmailAddressCC = data[0].EmailAddressCCMember
        this.dataSettingsCM.thresholdEmailAddressBCC = data[0].EmailAddressBCCMember
        this.dataSettingsCM.thresholdEmailSubject = data[0].EmailSubjectMember
        this.dataSettingsCM.warningMessage = data[0].WarningMessageMember

        this.dataSettingsIA.numberOfCalls = data[0].MaxNumCallsIPAddress;
        this.dataSettingsIA.numberOfHours = data[0].NumHoursIPAddress;
        this.dataSettingsIA.thresholdEmailAddressAlert = data[0].EmailAddressIPAddress;
        this.dataSettingsIA.thresholdActive = data[0].ThresholdActiveIPAddress;
        this.dataSettingsIA.thresholdEmailExceeds = data[0].SendEmailIPAddress;
        this.dataSettingsIA.thresholdEmailAddressCC = data[0].EmailAddressCCIPAddress
        this.dataSettingsIA.thresholdEmailAddressBCC = data[0].EmailAddressBCCIPAddress
        this.dataSettingsIA.thresholdEmailSubject = data[0].EmailSubjectIPAddress
        this.dataSettingsIA.warningMessage = data[0].WarningMessageIPAddress

        // this.warningMessageCI = `Global Warning: This caller ID has called ${data[0].MaxNumCallsCaller} or more times in the last ${data[0].NumHoursCaller} hours.`
        // this.warningMessageCM = `Global Warning: This member number has been used ${data[0].MaxNumCallsMember} or more times in the last ${data[0].NumHoursMember} hours.`
        // this.warningMessageIA = `Global Warning: This member number has been used ${data[0].MaxNumCallsIPAddress} or more times with different IP Address in the last ${data[0].NumHoursIPAddress} hours.`
        // this.warningMessageCI = this.dataSettingsCI.warningMessage
        // this.warningMessageCM = this.dataSettingsCM.warningMessage
        // this.warningMessageIA = this.dataSettingsIA.warningMessage
        // console.log(this.dataSettingsCI)
        // console.log(this.dataSettingsCM)
      } catch (error) {
        console.log(error)
      }
    },
    async updateThresholdSettings() {
      // const currentUser = JSON.parse(this.user);
      let dataSettings = {
        ci: this.dataSettingsCI,
        cm: this.dataSettingsCM,
        ia: this.dataSettingsIA,
        company: this.companyID,
        // user: `${currentUser.first_name} ${currentUser.last_name}`,
      }

      try {
        const { data } = await api.put("update_threshold", dataSettings)

        if (data.affectedRows == 1) {
          this.getThresholdSettings()
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
            this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
            "Threshold settings updated successfully."
          )
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancelThresholdSettings() {
      this.getThresholdSettings()
      flashMessage(
        this.$flashMessage,
        this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        "Threshold settings canceled successfully."
      )
    },
  },
}
</script>

<style scoped>
header {
  display: flex;
  justify-content: space-between;
}
.form-group {
  width: 230px;
}

.body-container {
  align-self: unset;
}
.settings-body {
  display: flex;
  /* justify-content: flex-start; */
}
table {
  border-spacing: 5px 10px;
  table-layout: fixed;
}
th {
  text-align: left;
  font-weight: bold;
}

tr {
  margin-bottom: 10px;
}
textarea {
  width: 97%;
  vertical-align: text-top;
}

tr td {
  vertical-align: top;
}
tr td:nth-child(1) {
  text-align: right;
  display: block;
  font-size: 16px;
  width: 376px;
}

tr td:nth-child(2) {
  vertical-align: top;
}
/*button {
    background-color: steelblue;
    color: white;
    border: 1px solid transparent;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 4px;
}*/

input[type="number"],
input[type="email"] {
  margin-left: 50px;
  /* border-radius: 2px;
    padding: 3px;
    border: 1px solid gray;*/
  outline: 0;
  /*    border-width: 0 0 1px;*/
  /*    border-color: grey;*/
  padding: 2px 5px;
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

fieldset > div {
  display: inline-block;
  margin-right: 6px;
  position: relative;
}

input[type="radio"] {
  position: relative;
  top: 2px;
}
</style>
